import { Table, Tooltip, Spin } from "antd";
import React, { useEffect, useState } from "react";
import deleteIcon from "../../../../../Assets/svg/table-action-delete.svg";
import editIcon from "../../../../../Assets/svg/table-action-edit.svg";
import previewIcon from "../../../../../Assets/svg/table-action-preview.svg";
import DeleteComponent from "../../../../components/DeleteComponent/DeleteComponent";
// import Edit from "./modals/Edit";
import Filters from "../Filters";
import { httpService } from "../../../../../services/httpService.service";
import addIcon from "../../../../../Assets/svg/plusIcon.svg";
import AddTrackingCardModal from "../../../planning/VisitBoard/Modals/AddTrackingCardModal";
import PreviewTracking from "./modals/PreviewTracking";
import { RolesEnum } from "../../../../../services/rolesEnum";
import { isAuthorized } from "../../../../../services/authService";
import MessagePopUp from "../../../../components/Messages/MessagePopUp";
import {
  formatDate,
  formatDateAndTime,
} from "../../../../../services/helpFunctions/formatDateAndTime";
import FacilityTag from "../../../../components/FacilityTag/FacilityTag";
import { months } from "../../../../../services/Enums/monthsAndYears";
import {
  IMPLEMENTATION_DEFAULT_COLUMNS,
  siteVisitPersonName,
} from "../../../../components/SiteVisitColumns/siteVisitColumnOrder";
import { useSiteVisitColumns } from "../../../../components/SiteVisitColumns/useSiteVisitColumns";

const statusMappingFieldTeamReportingStatus = (status) => {
  switch (status) {
    case 1:
      return {
        text: "Data collection",
        className: "dataCollection",
        fill: "#3B81FE",
      };
    case 2:
      return {
        text: "Data check",
        className: "dataCheck",
        fill: "#045B46",
      };
    case 3:
      return {
        text: "Field Reporting writing",
        className: "fieldReportWriting",
        fill: "var(--Range-assessment-Excellent, #3D9B4C)",
      };
    case 4:
      return {
        text: "Translation",
        className: "translation",
        fill: "#918d27",
      };
    case 5:
      return {
        text: "Field Reporting Completed",
        className: "fieldReportCompleted",
        fill: "#9670b8",
      };
    case 6:
      return {
        text: "Field report approved",
        className: "fieldReportApproved",
        fill: "var(--Graph-Green-1, #06768E)",
      };
    case 7:
      return {
        text: "Field report submitted to client",
        className: "fieldReportSubmitted",
        fill: "var(--Graph-Green-3, #6FC5D5)",
      };
    default:
      return {
        text: "Unknown",
        // className: "noStatus",
        fill: "white",
      };
  }
};

function TableView({
  tracked,
  siteVisitCards,
  fetchSiteVisitCards,
  loading,
  setLoading,
  onPageChange,
  pagination,
  setPagination,
  filters,
  setFilters,
  handleFilterChange,
  onOk,
  onRowSelectionChange,
}) {
  const [showEditModal, setShowEditModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedSiteVisit, setSelectedSiteVisit] = useState(null);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 576);
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });
  const [loadingDelete, setLoadingDelete] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 576);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleToggleEditModal = (record) => {
    const siteVisitCardId = record?.key;
    setSelectedSiteVisit(siteVisitCardId);
    setShowEditModal(!showEditModal);
  };

  const onOkey = () => {
    setShowEditModal(!showEditModal);
    onOk();
  };

  const handleTogglePreviewModal = (record) => {
    const siteVisitCardId = record?.key;
    setSelectedSiteVisit(siteVisitCardId);
    setShowPreviewModal(!showPreviewModal);
  };
  const [recordToDelete, setRecordToDelete] = useState();

  const handleDelete = (record) => {
    const siteVisitTrackingID = record?.trackingId;
    setRecordToDelete(siteVisitTrackingID);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (recordToDelete) {
      setLoadingDelete(true);
      httpService.delete(
        `/api/Site/deleteTrackings?includeIsDeleted=false`,
        [
          {
            id: recordToDelete,
            isDeleted: true,
          },
        ],
        (res) => {
          onOk();
          setShowDeleteModal(false);
          setLoadingDelete(false);
        },
        (err) => {
          setShowDeleteModal(false);
          setLoadingDelete(false);
        }
      );
    }
  };

  const columns = [
    {
      title: <span className="styledTitle">Site Visit Identifier</span>,
      sorter: (a, b) =>
        a.siteVisitIdentifier.localeCompare(b.siteVisitIdentifier),
      dataIndex: "siteVisitIdentifier",
      key: "siteVisitIdentifier",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Site Visit Name</span>,
      sorter: (a, b) => a.siteVisitName.localeCompare(b.siteVisitName),
      dataIndex: "siteVisitName",
      key: "siteVisitName",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },

    {
      title: <span className="styledTitle">Site Visit Status</span>,
      sorter: (a, b) => a.siteVisitStatus.localeCompare(b.siteVisitStatus),
      dataIndex: "siteVisitStatus",
      key: "siteVisitStatus",

      // Formating data for the table

      render: (text) => {
        let className;
        let fill;
        if (text === "Pre-planning phase") {
          className = "prePlanningPhase";
          fill = "var(--Primary-Blueberry-700, #325899)";
        } else if (text === "Planning") {
          className = "planning";
          fill = "#964B00";
        } else if (text === "Data collection") {
          className = "dataCollection";
          fill = "#3B81FE";
        } else if (text === "Post data collection/Data check") {
          className = "postDataCollection";
          fill = "#045B46";
        } else if (text === "Visit completed") {
          className = "visitCompleted";
          fill = "#0F7507";
        } else if (text === "No status") {
          className = "noStatus";
          fill = "rgba(172, 12, 12, 0.777)";
        } else {
          className = "noStatus";
          fill = "rgba(172, 12, 12, 0.777)";
        }
        return (
          <div className={`${className} m-0`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8px"
              height="8px"
              viewBox="0 0 9 9"
            >
              <circle cx="4.5" cy="4.27344" r="4" fill={fill} />
            </svg>
            <span>{text}</span>
          </div>
        );
      },
    },

    // Target date and actual date used to share one column that swapped
    // identity on `tracked`, which put the same header in two different places
    // depending on the tab. They are two columns now, each sitting at its own
    // fixed position: target date with the planning block, actual date with the
    // implementation block.
    {
      title: <span className="styledTitle">Date of Target Visit</span>,
      sorter: (a, b) =>
        (a.dateOfPlannedVisit || "").localeCompare(b.dateOfPlannedVisit || ""),
      dataIndex: "dateOfPlannedVisit",
      key: "dateOfPlannedVisit",
      render: (text) => (
        <span className="styledDataIndex3">{formatDateAndTime(text)}</span>
      ),
    },
    tracked && {
      title: <span className="styledTitle">Actual Date of Visit</span>,
      sorter: (a, b) => {
        const aDate = a.actualDateOfVisit?.[0]?.visitDate || "";
        const bDate = b.actualDateOfVisit?.[0]?.visitDate || "";
        return aDate.localeCompare(bDate);
      },
      dataIndex: "actualDateOfVisit",
      key: "actualDateOfVisit",
      render: (text, siteVisitCard) =>
        siteVisitCard?.actualDateOfVisit?.length ? (
          siteVisitCard.actualDateOfVisit.map((date) => (
            <span
              className="styledDataIndex3"
              style={{ display: "block" }}
              key={date.id}
            >
              {formatDate(date?.visitDate)}
            </span>
          ))
        ) : (
          <span className="styledDataIndex3">
            No actual date of visit available
          </span>
        ),
    },
    {
      title: <span className="styledTitle">Facility</span>,
      dataIndex: "facility",
      key: "facility",
      ellipsis: true,
      width: 250,
      sorter: (a, b) =>
        (a.facility?.name || "").localeCompare(b.facility?.name || ""),
      render: (facility) => <FacilityTag facility={facility} />,
    },
    tracked
      ? {
          title: <span className="styledTitle">Field Report Status</span>,
          dataIndex: "fieldTeamReportingStatus",
          key: "fieldTeamReportingStatus",
          width: 250,
          sorter: (a, b) => {
            const statusA = a.fieldTeamReportingStatus || "";
            const statusB = b.fieldTeamReportingStatus || "";
            return String(statusA).localeCompare(String(statusB));
          },
          render: (value, record) => {
            const { text, className, fill } =
              statusMappingFieldTeamReportingStatus(
                record?.fieldTeamReportingStatus
              );
            return (
              <div className={className}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8px"
                  height="8px"
                  viewBox="0 0 9 9"
                >
                  <circle cx="4.5" cy="4.27344" r="4" fill={fill} />
                </svg>
                <span className="styledDataIndex3">{text}</span>
              </div>
            );
          },
        }
      : null,
    {
      title: <span className="styledTitle">IP</span>,
      sorter: (a, b) => a.ip.localeCompare(b.ip),
      dataIndex: "ip",
      key: "ip",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Location</span>,
      sorter: (a, b) => a.location.localeCompare(b.location),
      dataIndex: "location",
      key: "location",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Governate/State</span>,

      dataIndex: "state",
      key: "state",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Cluster</span>,
      sorter: (a, b) => a.cluster.localeCompare(b.cluster),
      dataIndex: "cluster",
      key: "cluster",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Virtual</span>,
      sorter: (a, b) => a.virtual.localeCompare(b.virtual),
      dataIndex: "virtual",
      key: "virtual",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">TPM Coordinator</span>,
      dataIndex: "tpmCoordinator",
      key: "tpmCoordinator",
      sorter: (a, b) =>
        (a.tpmCoordinator || "").localeCompare(b.tpmCoordinator || ""),
      render: (text) => <span className="styledDataIndex3">{text || "—"}</span>,
    },
    {
      title: <span className="styledTitle">Team</span>,
      dataIndex: "team",
      key: "team",
      sorter: (a, b) => (a.team || "").localeCompare(b.team || ""),
      render: (text) => <span className="styledDataIndex3">{text || "—"}</span>,
    },
    // The implementation-phase columns. Only meaningful once a tracking record
    // exists, so the "Waiting for Tracking" tab doesn't carry empty ones.
    tracked && {
      title: <span className="styledTitle">Reporting Month-Year</span>,
      key: "reportingMonthYear",
      sorter: (a, b) =>
        `${a.reportingYear}-${a.reportingMonth}`.localeCompare(
          `${b.reportingYear}-${b.reportingMonth}`
        ),
      render: (text, record) => (
        <span className="styledDataIndex3">
          {record?.reportingMonth && record?.reportingYear
            ? `${months[Number(record.reportingMonth)] || record.reportingMonth}, ${record.reportingYear}`
            : "—"}
        </span>
      ),
    },
    tracked && {
      title: <span className="styledTitle">Training Completed</span>,
      dataIndex: "trainingIsCompleted",
      key: "trainingIsCompleted",
      sorter: (a, b) =>
        Number(!!a.trainingIsCompleted) - Number(!!b.trainingIsCompleted),
      render: (value) => (
        <span className="styledDataIndex3">{value ? "Yes" : "No"}</span>
      ),
    },
    tracked && {
      title: <span className="styledTitle">% Data Collection Completed</span>,
      dataIndex: "percentageOfDataCollectionCompleted",
      key: "percentageCompleted",
      sorter: (a, b) =>
        (a.percentageOfDataCollectionCompleted || 0) -
        (b.percentageOfDataCollectionCompleted || 0),
      render: (value) => (
        <span className="styledDataIndex3">
          {value === null || value === undefined ? "—" : `${value}%`}
        </span>
      ),
    },
    {
      title: <span className="styledTitle">Postponed</span>,
      dataIndex: "isPostponed",
      key: "isPostponed",
      sorter: (a, b) => Number(!!a.isPostponed) - Number(!!b.isPostponed),
      render: (value) => (
        <span className="styledDataIndex3">{value ? "Yes" : "No"}</span>
      ),
    },
    {
      title: <span className="styledTitle"></span>,
      key: "action",
      className:
        !isAuthorized([
          RolesEnum.SystemAdmin,
          RolesEnum.ProjectManager,
          RolesEnum.FieldCoordinator,
          RolesEnum.FieldLogistics,
          RolesEnum.DataAnalyst,
          RolesEnum.FieldTeamLeader,
        ]) && !tracked
          ? "d-none"
          : "",
      fixed: isLargeScreen && siteVisitCards.length > 0 ? "right" : undefined,
      width: !tracked && "5%",
      render: (text, record) => (
        <div className="actionDiv">
          {tracked && (
            <Tooltip title="Preview site visit">
              <img
                src={previewIcon}
                onClick={() => handleTogglePreviewModal(record)}
                style={{ cursor: "pointer" }}
              ></img>
            </Tooltip>
          )}
          {!tracked ? (
            <Tooltip placement="top" title={"Add tracking to this site visit!"}>
              {isAuthorized([
                RolesEnum.SystemAdmin,
                RolesEnum.ProjectManager,
                RolesEnum.FieldCoordinator,
                RolesEnum.FieldLogistics,
                RolesEnum.DataAnalyst,
                RolesEnum.FieldTeamLeader,
              ]) && (
                <img
                  src={addIcon}
                  onClick={() => handleToggleEditModal(record)}
                  style={{ cursor: "pointer" }}
                />
              )}
            </Tooltip>
          ) : (
            <>
              {isAuthorized([
                RolesEnum.SystemAdmin,
                RolesEnum.ProjectManager,
                RolesEnum.FieldCoordinator,
                RolesEnum.FieldLogistics,
                RolesEnum.DataAnalyst,
                RolesEnum.FieldTeamLeader,
              ]) && (
                <Tooltip title="Edit site visit">
                  <img
                    src={editIcon}
                    onClick={() => handleToggleEditModal(record)}
                    style={{ cursor: "pointer" }}
                  />
                </Tooltip>
              )}
            </>
          )}
          {isAuthorized([RolesEnum.SystemAdmin, RolesEnum.ProjectManager]) &&
            tracked && (
              <Tooltip title="Delete site visit">
                <img
                  src={deleteIcon}
                  style={{ cursor: "pointer" }}
                  onClick={() => handleDelete(record)}
                />
              </Tooltip>
            )}
        </div>
      ),
    },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      onRowSelectionChange(selectedRowKeys); // Use the destructured prop directly
    },
  };

  const formatStatus = (status) => {
    if (status == 1) {
      return "No status";
    } else if (status == 2) {
      return "Pre-planning phase";
    } else if (status == 3) {
      return "Planning";
    } else if (status == 4) {
      return "Data collection";
    } else if (status == 5) {
      return "Post data collection/Data check";
    } else if (status == 6) {
      return "Visit completed";
    } else {
      return "No status";
    }
  };

  const formatData = (siteVisitCard) => {
    return {
      key: siteVisitCard?.id,
      siteVisitIdentifier: siteVisitCard?.identifier,
      siteVisitName: siteVisitCard?.name,
      dateOfPlannedVisit: siteVisitCard?.visit?.plannedVisit,
      ip: siteVisitCard?.ipPlan?.implementingPartner?.name,
      location: siteVisitCard?.locationDetails?.country,
      state:
        siteVisitCard?.locationDetails?.state || "This country has no states.",
      cluster: siteVisitCard?.cluster?.name,
      virtual: siteVisitCard?.isVirtual ? "Yes" : "No",
      siteVisitStatus: formatStatus(siteVisitCard.siteVisitStatus),
      reportingYear: siteVisitCard?.tracking?.reportingYear,
      reportingMonth: siteVisitCard?.tracking?.reportingMonth,
      trackingId: siteVisitCard?.tracking?.id,
      trainingDate: siteVisitCard?.tracking?.trainingDate,
      trainingScoreInfo: siteVisitCard?.tracking?.trainingScoreInfo,
      actualDateOfVisit: siteVisitCard?.tracking?.siteTrackingVisitDates,
      dateOfReport: siteVisitCard?.tracking?.dateOfReport,
      dateOfDebrief: siteVisitCard?.tracking?.dateOfDebrief,
      percentageOfDataCollectionCompleted:
        siteVisitCard?.tracking?.percentageOfDataCollectionCompleted,
      fieldTeamReportingStatus:
        siteVisitCard?.tracking?.fieldTeamReportingStatus,
      trainingIsCompleted: siteVisitCard?.tracking?.trainingIsCompleted,
      facility: siteVisitCard?.facility,
      tpmCoordinator: siteVisitPersonName(
        siteVisitCard?.logistic?.tpmCoordinator
      ),
      team: siteVisitCard?.logistic?.team?.name,
      isPostponed: siteVisitCard?.logistic?.isPostponed,
    };
  };

  const formattedData = siteVisitCards?.map(formatData);

  // Separate ids per tab: someone watching "Tracking in Progress" wants a
  // different set on screen than someone triaging "Waiting for Tracking".
  const {
    columns: visibleColumns,
    columnsBar,
    components: tableComponents,
  } = useSiteVisitColumns({
    tableId: tracked ? "implementationTracked" : "implementationWaiting",
    columns,
    defaultKeys: IMPLEMENTATION_DEFAULT_COLUMNS,
  });

  return (
    <div style={{ paddingTop: "20px", borderBottom: "1px solid #e1e1e1" }}>
      <h5 className="tableViewHeaderText" style={{ fontSize: "20px" }}>
        {tracked ? "Tracking in Progress" : "Waiting for Tracking"}
      </h5>
      <MessagePopUp
        trigger={message.trigger}
        type={message.type}
        icon={message.icon}
        messageTitle={message.title}
        messageText={message.text}
      />
      <Filters
        tracked={tracked}
        filters={filters}
        setFilters={setFilters}
        setPagination={setPagination}
      />
      <div
        className="w-100 my-3 d-flex justify-content-start gap-2"
        style={{
          color: "var(--2, #AA1A5F)",
          fontFamily: "Poppins",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "600",
          lineHeight: "24px",
        }}
      >
        {loading ? (
          <Spin className="me-2" size="small" spinning={loading} />
        ) : (
          `Total: ${pagination.total} visits`
        )}
        {columnsBar && <span className="ms-auto">{columnsBar}</span>}
      </div>
      <div>
        <Table
          components={tableComponents}
          loading={loading}
          rowSelection={formattedData.length > 0 ? { ...rowSelection } : ""}
          dataSource={formattedData}
          columns={formattedData?.length > 0 ? visibleColumns : []}
          pagination={{
            ...pagination,
            onChange: onPageChange,
          }}
          className="tableTPM"
          scroll={{ x: "max-content" }}
        />
      </div>
      <AddTrackingCardModal
        visible={showEditModal}
        onCancel={handleToggleEditModal}
        onOk={() => onOkey()}
        siteVisitCardId={selectedSiteVisit}
        tracked={tracked}
        setMessage={setMessage}
        fetchSiteVisitCards={fetchSiteVisitCards}
      />
      <PreviewTracking
        visible={showPreviewModal}
        onClose={handleTogglePreviewModal}
        siteVisitCardId={selectedSiteVisit}
      />
      <DeleteComponent
        visible={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        text={
          "You're about to delete the tracking for this site visit card. This action can’t be undone."
        }
        header={"Delete "}
        onConfirm={handleConfirmDelete}
        loading={loadingDelete}
      />
    </div>
  );
}

export default TableView;
